import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SITE_ROUTES } from 'shared/enums/routes.enum';
import { MenuDTO } from 'shared/models/common/menu';
import { Icon } from '../icon/icon';
import { RouterService } from 'core/services/router.service';
import { TranslateModule } from '@ngx-translate/core';
import { UtilsService } from 'core/services/utils.service';
import { StorageService } from 'core/services/storage.service';
import { AuthService } from 'features/auth/auth.service';
import { AlertService } from 'core/services/alert.service';
import { TranslationService } from 'core/services/translation.service';
import { PAGES_PERMISSIONS } from 'shared/enums/permissions.enum';
import { DialogService } from 'core/services/dialog.service';
import { ChangePassword } from '../dialogs/change-password/change-password';

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    Icon,
    TranslateModule
  ],
  providers: [
    RouterService,
    UtilsService,
    AuthService
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar implements OnInit {
  menus: MenuDTO[] = [
    {
      title: 'dashboard',
      icon: 'assets/images/common/home-icon-gray.svg',
      activeIcon: 'assets/images/common/home-icon-primary.svg',
      link: SITE_ROUTES.DASHBOARD,
      permissions: []
    },
    {
      title: 'companies',
      icon: 'assets/images/common/briefcase.svg',
      activeIcon: 'assets/images/common/briefcase-blue.svg',
      link: SITE_ROUTES.COMPANIES_LISTING,
      permissions: []
    },
    {
      title: 'commission',
      icon: 'assets/images/common/coins-gray.svg',
      activeIcon: 'assets/images/common/coins-blue.svg',
      link: SITE_ROUTES.COMMISSION_LISTING,
      permissions: []
    },
    {
      title: 'affiliation',
      icon: 'assets/images/common/equipment-icon-gray.svg',
      activeIcon: 'assets/images/common/equipment-icon-primary.svg',
      link: SITE_ROUTES.AFFILIATION_DASHBOARD,
      permissions: []
    },
    {
      title: 'Tickets',
      icon: 'assets/images/common/ticket-gray.svg',
      activeIcon: 'assets/images/common/ticket-primary.svg',
      link: SITE_ROUTES.TICKETS,
      permissions: []
    },
  ]

  constructor(
    private routerService: RouterService,
    private utilsService: UtilsService,
    public storageService: StorageService,
    private authService: AuthService,
    private alertService: AlertService,
    private translationService: TranslationService,
    private dialogService: DialogService
  ) { }

  isMenuActive(menu: MenuDTO) {
    const currentPath = this.utilsService.splitPathBySlash(window.location.pathname)[2];
    const menuPath = this.utilsService.splitPathBySlash(menu.link)[2];
    return currentPath === menuPath;
  }

  goToMenu(path: string) {
    if (path) {
      this.routerService.navigate(path);
      this.handleHideSidebar();
    } else {
      this.alertService.warningToaster('This feature is under development');
    }
  }

  async logout() {
    const logoutConfirmation = this.translationService.getTranslation('logoutConfirmation');
    const { isConfirmed } = await this.alertService.confirmationPopup(logoutConfirmation);
    if (isConfirmed) this.authService.logout().subscribe();
  }

  openConfirmPasswordDialog() {
    this.dialogService.openDialog(ChangePassword)
  }

  getMyProfile() {
    this.authService.getMyProfile().subscribe({
      next: () => {
        if (this.storageService.isUserBlocked) {
          this.authService.logout().subscribe()
        }
      }
    })
  }

  handleHideSidebar() {
    if (window.innerWidth <= 1024) {
      this.storageService.hideSidebar();
    }
  }

  protected get profilePic() {
    return this.storageService.profilePic;
  }

  ngOnInit(): void {
    this.getMyProfile();
  }
}
